/**
 * Filtra devoluciones por obra, depósito, responsable o motivo.
 * @param {Array<Object>} rows Devoluciones.
 * @param {string} search Texto buscado.
 * @returns {Array<Object>}
 */
export const filterReturns = (rows = [], search = '') => {
  const term = search.trim().toLowerCase();
  if (!term) return rows;
  return rows.filter((row) =>
    `${row.project_label} ${row.warehouse_name} ${row.responsible} ${row.reason}`
      .toLowerCase()
      .includes(term)
  );
};
